import { useMemo } from "react";
import type { UserRoles } from "~enums/userRoles";
import { userRolesByPriority } from "~pages/Users/constants/userRolesByPriority.ts";
import { DEFAULT_ROLE_CONFIG, userRolesConfig } from "~pages/Users/constants/userRolesConfig.ts";
import type { PermissionProducts } from "~pages/Users/enums/permissionProducts.ts";
import type { UserPermissionTransformed } from "~pages/Users/types";

const useGroupAndSortPermissionsByProduct = (
  permissions: UserPermissionTransformed[] | undefined,
): { [key in PermissionProducts]?: UserPermissionTransformed[] } =>
  useMemo(() => {
    const sortedPermissions = (permissions || []).sort(
      (a, b) => userRolesByPriority.indexOf(a.userRole as UserRoles) - userRolesByPriority.indexOf(b.userRole as UserRoles),
    );

    return sortedPermissions.reduce<{
      [key in PermissionProducts]?: UserPermissionTransformed[];
    }>((accumulator, currentValue) => {
      const roleConfig = userRolesConfig[currentValue.userRole as UserRoles] || DEFAULT_ROLE_CONFIG;
      if (roleConfig.product in accumulator) {
        accumulator[roleConfig.product]?.push(currentValue);
      } else {
        accumulator[roleConfig.product] = [currentValue];
      }
      return accumulator;
    }, {});
  }, [permissions]);

export default useGroupAndSortPermissionsByProduct;
